module.exports = __webpack_public_path__ + "img/logo-card-02.4f7c10d8.png";